export default "/public/dist/img/IMG3.png";